import { Controller } from 'stimulus';

class AdvisoryController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    import(/* webpackChunkName: "advisory" */ '../advisory').then((module) => {
      module.default(this.appTarget);
    });
  }
}

AdvisoryController.targets = [
  'app',
];

export default AdvisoryController;
